<template>
  <!--<div>-->
  <div class="partnersMain">
    <!--banner+导航-->
    <div class="bannerBox" >
      <img  ref="homeBanner" src="../../../assets/img/onlineBanner.jpg"/>
      <div class="topTextBox">
        <!--导航-->
        <top-nav></top-nav>
        <!--<top-nav :nav-index1="6"></top-nav>-->
      </div>
    </div>
    <div class="servicesContent">
      <div class="contentW">
        <div class="services01"  id="m1">
          <div style="width: 100%;margin: auto;min-width: 62.5rem;" >
            <div class="leftBox animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'"><img src="../../../assets/icon/servicesImg1.png"/><div class="box"></div></div>
            <div class="rightBox animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'">
              <div class="titles">WeChat Moment Ads</div>
              <div class="contents">Let the Ads exist when needed.</div>
              <div class="btn" @click="navClick('/contact')">CONTACT US</div>
            </div>
          </div>
        </div>

        <div class="services02" id="m2">
          <div style="width: 100%;margin: auto;min-width: 62.5rem;">
            <div class="rightBox animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'">
              <div class="titles">Payment Successful page Ads</div>
              <div class="contents">More than 10000 transactions per <br/>day, WeChat platform promotion. </div>
              <div class="btn" @click="navClick('/contact')">CONTACT US</div>
            </div>
            <div class="leftBox animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'"><img src="../../../assets/icon/servicesImg2.png"/></div>
          </div>
        </div>
      </div>

      <div class="services03">
        <div class="contentW" id="m3">
          <div class="titles animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">Multi-Platform Campaign</div>
          <ul class="contentUl animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon1.png"/></div>
              <div class="textBox">
                <div class="titleText">Alipay Red Pocket</div>
                <div class="contentText">Scan the QR code and Alipay will send customers a random amount of money to use in future purchase.</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon2.png"/></div>
              <div class="textBox">
                <div class="titleText">WeChat Pay Lucky Money</div>
                <div class="contentText">WeChat will send customers a random amount of money to use in their e-wallet before purchase.</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon3.png"/></div>
              <div class="textBox">
                <div class="titleText">Festival Campaigns</div>
                <div class="contentText">Both Alipay and WeChat Pay offer multiple festival campaigns for customers to earn real money by scanning the campaign code.</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="contentW" id="m4">
          <div class="titles animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">WeChat Pay promotion</div>
          <ul class="contentUl animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon4.png"/></div>
              <div class="textBox">
                <div class="titleText">WeChat Moments Ads</div>
                <div class="contentText">Apply WeChat Moments Ad to expand your brand reach to 2,900,000 active WeChat users in Australia.</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon5.png"/></div>
              <div class="textBox">
                <div class="titleText">Payment Successful Page Ads</div>
                <div class="contentText">Advertise on WeChat Pay payment successful page for over 10,000 exposures per day.</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon6.png"/></div>
              <div class="textBox">
                <div class="titleText">Gift Pack Mini Program</div>
                <div class="contentText">It is a mini program that WeChat Pay released to overseas market, which contains deals and offers provided by both merchants and WeChat Pay.</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="contentW" id="m5">
          <div class="titles animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">Alipay promotion</div>
          <ul class="contentUl animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon7.png"/></div>
              <div class="textBox">
                <div class="titleText">Alipay Discover Promotion</div>
                <div class="contentText">Merchant listing in Alipay Discover platform can have detailed description of the store location, customer's review and special offers displayed and pushed in the user’s Alipay App.</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon8.png"/></div>
              <div class="textBox">
                <div class="titleText">Alipay City Card</div>
                <div class="contentText">Merchants can provide offers and it will be listed on the Alipay City Card, which is one of the most popular Alipay promotion platforms.</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon9.png"/></div>
              <div class="textBox">
                <div class="titleText">Alipay Week</div>
                <div class="contentText">Each week Alipay offers different promotion, one for twenty, spend one CNY to exchange a 20 CNY coupon.</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>

    <!--底部-->
    <Footer></Footer>

  </div>
  <!--</div>-->
</template>

<script>
  import topNav from './nav'
  import Footer from "@/components/Footer"
  let timer = null; //定义初始值
  export default {
    name: "services",
    components:{topNav,Footer},
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },
    data() {
      return {
        animates:{
          mm1:false,
          mm2:false,
          mm3:false,
          mm4:false,
          mm5:false,
        },
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    },
    mounted () {
      document.documentElement.scrollTop=0;

      this.animates.mm1 = true;
      if(window.innerWidth>1200){
        window.addEventListener('scroll', this.handleScroll)
      }else {
        this.animates.mm2 = true;
        this.animates.mm3 = true;
        this.animates.mm4 = true;
        this.animates.mm5 = true;
      }
    },
    methods:{
      //  点击导航
      navClick(url){
        this.$router.push(url);
      },


      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        // var offsetTop1 = document.querySelector('#m1').offsetTop;
        var offsetTop2 = document.querySelector('#m2').offsetTop;
        var offsetTop3 = document.querySelector('#m3').offsetTop;
        var offsetTop4 = document.querySelector('#m4').offsetTop;
        var offsetTop5 = document.querySelector('#m5').offsetTop;



        if (scrollTop > offsetTop2-200) {
          this.animates.mm2 = true
        } else {
          this.animates.mm2 = false
        }
        if (scrollTop > offsetTop3-1000) {
          this.animates.mm3 = true
        } else {
          this.animates.mm3 = false
        }
        if (scrollTop > offsetTop4-1000) {
          this.animates.mm4 = true
        } else {
          this.animates.mm4 = false
        }
        if (scrollTop > offsetTop5-1000) {
          this.animates.mm5 = true
        } else {
          this.animates.mm5 = false
        }
      },


      //置顶
      toTop(){ // 动画

        timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          // this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    }
  }
</script>

<style scoped>

  body{min-width: 1345px;}

  .partnersMain{width: 100%;height: auto;}
  .partnersMain .bannerBox{width: 100%;height: auto;position: relative;}
  .partnersMain .bannerBox>img{width: 100%;}
  .partnersMain .bannerBox .topTextBox{width: 100%;height: 100%;position: absolute;top: 0;left: 0;}


  /*内容部分*/
  .servicesContent{width: 100%;height: auto;padding: 2rem 0 0rem 0;background-color: #fff;}

  /*模块1*/
  .services01{width: 100%;height: auto;overflow: hidden;border-bottom: 1px solid #979797;padding-top: 5rem;}
  .services01 .leftBox{width: 50%;height: 100%;float: left;text-align: left;position: relative;}
  .services01 .leftBox>img{width: 360px;padding-left: 25%;}
  .services01 .leftBox>.box{width: 100%;height: 50px;position: absolute;bottom: 0;
    background: -webkit-linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.8)); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.8)); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.8)); /* Firefox 3.6 - 15 */
    background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.8)); /* 标准的语法 */
  }
  .services01 .rightBox{width: calc(50% - 30px);height: 100%;float: right;}
  .services01 .rightBox .titles{font-size: 2.25rem;font-family: MontserratRegular;color: #4a4a4a;line-height: 3rem;margin-top: 5rem;}
  .services01 .rightBox .contents{font-size: 1.25rem;font-family: Montserrat300;color: #4a4a4a;line-height: 1.8rem;margin-top: 2rem;}
  .services01 .rightBox .btn{font-size: 0.97rem;width: 8rem; font-family: MontserratMedium;text-align: center; color: #4a4a4a;height: 2.7rem; line-height: 2.7rem;margin-top: 2rem;border: 1px solid #4a4a4a;border-radius: 4px;cursor: pointer;}


  /*模块2*/
  .services02{width: 100%;height: auto;overflow: hidden;padding-top: 53px;}
  .services02 .leftBox{width: calc(50% - 30px);height: 100%;float: right;text-align: center;position: relative; }
  .services02 .leftBox>img{width: 468px;}
  .services02 .rightBox{width: calc(50% + 30px);height: 100%;float: left;}
  .services02 .rightBox .titles{font-size: 2.25rem;font-family: MontserratRegular;color: #4a4a4a;line-height: 3rem;margin-top: 5rem;margin-left: 25%;}
  .services02 .rightBox .contents{font-size: 1.25rem;font-family: Montserrat300;color: #4a4a4a;line-height: 1.8rem;margin-top: 2rem;margin-left: 25%;}
  .services02 .rightBox .btn{font-size: 0.97rem;width: 8rem; font-family: MontserratMedium;text-align: center; color: #4a4a4a;height: 2.7rem;margin-left: 25%; line-height: 2.7rem;margin-top: 2rem;border: 1px solid #4a4a4a;border-radius: 4px;cursor: pointer;}

  /*模块3*/
  .services03{width: 100%;height:auto;padding:5rem 0; background-color: #f6f6f6;}
  .services03 .titles{padding-top: 2rem;width: 100%;height: 5rem;line-height: 5rem;font-family: Montserrat300;font-size: 1.5rem;text-align: center;border-bottom: 1px solid #979797;}
  .services03 .contentUl{width: calc(100% - 4rem);height: 13.75rem;overflow: hidden;padding:3rem 2rem;}
  .services03 .contentUl>li{float: left;width: 33.33%;height: 100%;}
  .services03 .contentUl>li .iconBox{width: 6rem;height: 100%;float: left;text-align: center; }
  .services03 .contentUl>li .textBox{width: calc(90% - 6rem);min-width: 17.5rem; float: left;height: 100%;}
  .services03 .contentUl>li .textBox .titleText{width: 100%;height: auto;font-family: Montserrat600;font-size: 1rem;color: #4a4a4a;line-height: 3rem;}
  .services03 .contentUl>li .textBox .contentText{width: 100%;height: auto;font-family: Montserrat300;font-size: 0.875rem;color: #4a4a4a;line-height: 1.8rem;}

  .hideBox{display: none;}

.uline{
  /* height:1px; */
  margin-top: 10px;
  border-bottom: #4a4a4a 1px solid;
}
.privacy {
  /* border-top: #4a4a4a 1px solid; */
  margin-top: 10px;
}
</style>
